export const SET_ERROR = "[errorHandler] SET_ERROR";
